<div class="bg-white min-h-screen">
    <!-- Hero Section -->
    <div class="bg-app-background-20 py-16 border-b border-gray-200">
        <div class="max-w-4xl mx-auto px-6">
            <h1 class="text-4xl font-fraunce text-app-primary-20 mb-4">Allgemeine Geschäftsbedingungen</h1>
            <p class="text-app-secondary-10 text-xl">Nutzungsbedingungen für das Patriacura Arztportal</p>
        </div>
    </div>

    <!-- Content -->
    <div class="max-w-4xl mx-auto px-6 py-16">
        <div class="grid grid-cols-1 gap-12">

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 1 Allgemeines</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <p>Die Nutzung dieser Webseite richtet sich nach den vorliegenden allgemeinen Geschäftsbedingungen. Abweichende Vereinbarungen bedürfen der Schriftform.</p>
                    <p class="font-medium">Anbieterin: Patriacura als Marke der Aliacura e.K. (nachfolgend „Anbieterin“)</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 2 Leistungsumfang</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <p>Die Anbieterin stellt Ärzten und Apotheken eine Internet-Plattform zur Verfügung, über die Patienten online ärztliche Leistungen erhalten und Rezepte an ihre Wunschapotheke schicken lassen können.</p>
                    <div class="bg-gray-50 p-6 rounded-lg grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div class="flex items-start gap-3">
                            <i class="fa-solid fa-circle-check text-app-primary-10 mt-1"></i>
                            <span>Symptomerhebung & Übermittlung</span>
                        </div>
                        <div class="flex items-start gap-3">
                            <i class="fa-solid fa-circle-check text-app-primary-10 mt-1"></i>
                            <span>Qualitätssicherung & Datenschutz</span>
                        </div>
                        <div class="flex items-start gap-3">
                            <i class="fa-solid fa-circle-check text-app-primary-10 mt-1"></i>
                            <span>Digitale Rezept-Ausstellung</span>
                        </div>
                        <div class="flex items-start gap-3">
                            <i class="fa-solid fa-circle-check text-app-primary-10 mt-1"></i>
                            <span>Höchste Datensicherheit</span>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 3 Kosten und Vertragsschluss</h2>
                <div class="text-app-secondary-10 space-y-6">
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Preise</h3>
                        <p>Die Nutzung der Services ist kostenpflichtig. Die Preise sind jeweils angegeben und enthalten insbesondere die Gebühren für ärztliche Leistungen.</p>
                    </div>
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Vertragspartner</h3>
                        <p>Behandlungsverträge kommen ausschließlich zwischen Patient und Arzt zustande. Die Anbieterin ist selbst nicht Vertragspartner der medizinischen Leistung, sondern übernimmt die technische Bereitstellung und Zahlungsabwicklung.</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 4 Pflichten des Nutzers</h2>
                <div class="text-app-secondary-10">
                    <p>Angaben müssen korrekt und vollständig sein. Bei Verdacht auf Missbrauch kann der Zugang jederzeit gesperrt werden.</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 5 Haftung und Verfügbarkeit</h2>
                <div class="text-app-secondary-10">
                    <p>Haftung nur bei wesentlichen Vertragspflichten. Keine Haftung für Behandlungs- oder Medikationsfehler des Arztes. Es besteht kein Recht auf ständige Verfügbarkeit des Angebots.</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 6 Widerrufsbelehrung</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <p>Ein Widerrufsrecht besteht nicht für medizinische Leistungen oder individuelle Herstellungen. Für andere Dienstleistungen gilt eine 14-tägige Widerrufsfrist ab Vertragsabschluss.</p>
                    <div class="p-4 bg-app-background-20 border border-app-primary-10/20 rounded">
                        <p class="font-medium mb-2 underline italic">Muster-Widerrufsformular:</p>
                        <p class="text-sm">Hiermit widerrufe ich den Vertrag über die Erbringung folgender Dienstleistung... [Bestellt am / Erhalten am / Name / Anschrift / Datum]</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">§ 7 Schlussbestimmungen</h2>
                <div class="text-app-secondary-10">
                    <p>Anwendbar ist deutsches Recht. Gerichtsstand ist Scheinfeld. Sollten einzelne Bestimmungen unwirksam sein, bleiben die übrigen wirksam (Salvatorische Klausel).</p>
                </div>
            </section>
        </div>
    </div>
</div>
